import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FormSectionProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

export function FormSection({ title, icon, children, collapsible = false, defaultExpanded = true }: FormSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    if (collapsible) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      {/* Section Header */}
      <div
        className={`flex items-center gap-2 pb-2 border-b border-gray-300 transition-all duration-200 ${
          collapsible ? 'cursor-pointer select-none hover:border-primary-300' : ''
        } ${isExpanded ? 'mb-3' : 'mb-0'}`}
        onClick={toggleExpanded}
      >
        {icon && <div className="text-primary-500">{icon}</div>}
        <h3 className="text-base font-semibold text-gray-800 m-0 flex-1">{title}</h3>
        {collapsible && (
          <div className={`text-gray-600 transition-transform duration-400 ease-in-out ${isExpanded ? 'rotate-180' : 'rotate-0'}`}>
            <ExpandMoreIcon sx={{ fontSize: 20 }} />
          </div>
        )}
      </div>

      {/* Section Content with smooth animation */}
      <div
        style={{
          display: 'grid',
          gridTemplateRows: isExpanded ? '1fr' : '0fr',
          transition: 'grid-template-rows 400ms ease-in-out',
        }}
      >
        <div style={{ overflow: isExpanded ? 'visible' : 'hidden' }}>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}
